import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import { Router } from '@angular/router';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    hasError:boolean = false;
    constructor(
        private authenticationService: AuthenticationService,

        private router: Router
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((err: HttpErrorResponse) => {
                let errorMessage = '';
                if (err.status === 401) {
                    // auto logout if 401 response returned from api
                    this.authenticationService.logout();
                    this.router.navigate(['/login'], { skipLocationChange: true });
                }else if(err.status === 0 && !this.hasError){
                    this.hasError = true;
                }
                if (err.error instanceof ErrorEvent) {
                    // client-side error
                    errorMessage = `Error: ${err.error.message}`;
                  } else {
                    // server-side error
                    errorMessage = `Error Code: ${err.status}\n Message: ${err.message}`;
                  }
                  //console.log(err);
                return throwError(errorMessage);
            })
        )
    }
}

